// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

/* \\/\\/\\/ GLOBAL \\/\\/\\/ */
.parent {
  height: 65vh;
  width: 100%; }

.blurb-container {
  font-family: var(--main-font);
  color: white;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between; }
  .blurb-container.disc {
    height: 135px; }
  .blurb-container.forest {
    height: 135px; }
  .blurb-container.home {
    height: 115px;
    bottom: 0%; }
  .blurb-container > div {
    padding: 5px 5px; }

/* /\\/\\/\\ GLOBAL /\\/\\/\\ */
/* \\/\\/\\/ AI CHAT \\/\\/\\/ */
.constuction-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; }

.construction-text {
  position: absolute;
  font-size: xx-large;
  top: 0;
  margin-top: 130px;
  color: white;
  font-family: var(--main-font); }

.construction-gif {
  position: absolute;
  bottom: 0;
  margin-bottom: 140px; }
  @media screen and (max-width: 430px) {
    .construction-gif {
      width: 100%; } }

/* /\\/\\/\\ AI CHAT /\\/\\/\\ */
/* \\/\\/\\/ SOUNDLOG \\/\\/\\/ */
.forest-arrow {
  width: 200px;
  height: 200px;
  position: absolute;
  transform: rotate(180deg);
  bottom: 0;
  left: 40%; }

/* /\\/\\/\\ SOUNDLOG /\\/\\/\\ */
/* \\/\\/\\/ DISCORDANCE \\/\\/\\/ */
.disc-div {
  overflow: hidden;
  display: flex;
  justify-content: center; }

.disc-arrow-div {
  position: absolute;
  width: 150px;
  height: 150px;
  bottom: 28%;
  right: 29%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: var(--log-in-font); }

/* /\\/\\/\\ DISCORDANCE /\\/\\/\\ */
/* \\/\\/\\/ RESUME/ABOUT ME \\/\\/\\/ */
.resume-container,
.about-me-container {
  font-family: var(--main-font); }

.about-me-container {
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  justify-content: flex-start;
  align-items: flex-start; }
  .about-me-container.parent {
    height: -moz-fit-content;
    height: fit-content; }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/ModalComponents/Components.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB,yBAAA;AACA;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,oCAAsC;EACtC,WAAW;EAEX,gBAAgB;EAEhB,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAXlC;IAcQ,aAAa,EAAA;EAdrB;IAkBQ,aAAa,EAAA;EAlBrB;IAsBQ,aAAa;IACb,UAAU,EAAA;EAvBlB;IA2BQ,gBAAgB,EAAA;;AAIxB,yBAAA;AAEA,0BAAA;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;;AAGpB;EACI,kBAAkB;EAClB,mBAAmB;EACnB,MAAM;EACN,iBAAiB;EACjB,YAAY;EAEZ,6BAA6B,EAAA;;AAGjC;EACI,kBAAkB;EAClB,SAAS;EACT,oBAAoB,EAAA;EAEpB;IALJ;MAMQ,WAAW,EAAA,EAElB;;AAED,0BAAA;AAIA,2BAAA;AAEA;EACI,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,SAAS,EAAA;;AAGb,2BAAA;AAGA,8BAAA;AAEA;EACI,gBAAgB;EAChB,aAAa;EACb,uBAAuB,EAAA;;AAG3B;EACI,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EAEnB,+BAA+B,EAAA;;AAGnC,8BAAA;AAEA,kCAAA;AAEA;;EAEI,6BAA6B,EAAA;;AAGjC;EACI,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB,EAAA;EAL3B;IAQQ,wBAAmB;IAAnB,mBAAmB,EAAA","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import '../style_imports/fonts';\n\n/* \\/\\/\\/ GLOBAL \\/\\/\\/ */\n.parent {\n    height: 65vh;\n    width: 100%;\n}\n\n.blurb-container {\n    font-family: var(--main-font);\n    color: white;\n    position: absolute;\n    background-color: rgba($color: #000000, $alpha: .5);\n    width: 100%;\n    // left: 5%;\n    overflow-y: auto;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    &.disc {\n        height: 135px;\n    }\n\n    &.forest {\n        height: 135px;\n    }\n\n    &.home {\n        height: 115px;\n        bottom: 0%;\n    }\n\n    &>div {\n        padding: 5px 5px;\n    }\n}\n\n/* /\\/\\/\\ GLOBAL /\\/\\/\\ */\n\n/* \\/\\/\\/ AI CHAT \\/\\/\\/ */\n\n.constuction-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n\n.construction-text {\n    position: absolute;\n    font-size: xx-large;\n    top: 0;\n    margin-top: 130px;\n    color: white;\n\n    font-family: var(--main-font);\n}\n\n.construction-gif {\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 140px;\n\n    @media screen and (max-width: 430px) {\n        width: 100%;\n    }\n}\n\n/* /\\/\\/\\ AI CHAT /\\/\\/\\ */\n\n\n\n/* \\/\\/\\/ SOUNDLOG \\/\\/\\/ */\n\n.forest-arrow {\n    width: 200px;\n    height: 200px;\n    position: absolute;\n    transform: rotate(180deg);\n    bottom: 0;\n    left: 40%;\n}\n\n/* /\\/\\/\\ SOUNDLOG /\\/\\/\\ */\n\n\n/* \\/\\/\\/ DISCORDANCE \\/\\/\\/ */\n\n.disc-div {\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n}\n\n.disc-arrow-div {\n    position: absolute;\n    width: 150px;\n    height: 150px;\n    bottom: 28%;\n    right: 29%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    font-family: var(--log-in-font);\n}\n\n/* /\\/\\/\\ DISCORDANCE /\\/\\/\\ */\n\n/* \\/\\/\\/ RESUME/ABOUT ME \\/\\/\\/ */\n\n.resume-container,\n.about-me-container {\n    font-family: var(--main-font);\n}\n\n.about-me-container {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.5;\n    justify-content: flex-start;\n    align-items: flex-start;\n\n    &.parent {\n        height: fit-content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
